export const notfound = {
  "notfound.title": "Page Non Trouvée",
  "notfound.subtitle": "La page que vous recherchez n'existe pas ou a été déplacée"
};

export default notfound;